import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input, Menu, Segment, Form, Button } from 'semantic-ui-react'
import './DnsManagerRoute.css';

export default class DnsManager extends Component {
  static propTypes = {
    getDomains: PropTypes.func,
    getDomainRecords: PropTypes.func,
    domains: PropTypes.array,
    records: PropTypes.array,
    addRecord: PropTypes.func,
    editRecord: PropTypes.func,
    loadingDomains: PropTypes.bool,
    loadingRecords: PropTypes.bool
  }

  constructor(props) {
    super(props);
    this.state = {
      search: ''
    }
  }

  componentDidMount() {
    this.props.getDomains();
    if (this.props.match.params && this.props.match.params.domain)
      this.props.getDomainRecords(this.props.match.params.domain)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.domain !== this.props.match.params.domain)
      this.props.getDomainRecords(this.props.match.params.domain)
  }

  search = (e, { value }) => this.setState({ search: value })

  edit = idx => {
    const { name, data, type } = this.props.records[idx]
    this.setState({ editing: idx, name, data, type })
  }

  onEditChange = field => (e, { value }) => this.setState({ [field]: value })

  cancelEdit = () => this.setState({ editing: null, name: null, data: null, type: null })

  saveEdit = () => {
    const { name, data, type } = this.state;
    this.props.editRecord(this.props.match.params.domain, {
      subdomain: name,
      ip: data,
      type,
      idx: this.state.editing
    })
    this.cancelEdit()
  }

  addRecord = () => {
    const { newName: subdomain, newData: ip, newType: type } = this.state;
    this.props.addRecord(this.props.match.params.domain, {
      subdomain,
      ip,
      type
    })
    this.setState({ newName: '', newData: '', newType: '' })
  }

  render() {
    return (
      <div className="DnsManagerRoute">
        <Menu vertical>
          <Menu.Item>
            <Input icon='search' placeholder='Search Domains' size="mini" loading={this.props.loadingDomains} onChange={this.search} />
          </Menu.Item>
          {
            this.props.domains ? this.props.domains.filter(domain => domain.domain.includes(this.state.search)).map(domain => (
              <Menu.Item active={this.props.match.params.domain === domain.domain} onClick={() => this.props.push(`/domains/${domain.domain}`)} name={domain.domainId}>
                {<div className="custom-header" dangerouslySetInnerHTML={{ __html: domain.domain.replace(this.state.search, `<b>${this.state.search}</b>`) }} />}
              </Menu.Item>
            )) : null
          }
        </Menu>
        {
          this.props.match.params.domain ?
          <Segment loading={this.props.loadingRecords}>
            <Form size="mini">
              <Form.Group widths='equal'>
                <Form.Input label='Sub-domain' placeholder='Sub-Domain' value={this.state.newName} onChange={this.onEditChange('newName')} />
                <Form.Input label='IP' placeholder='IP' value={this.state.newData} onChange={this.onEditChange('newData')} />
                <Form.Select label='Type' placeholder='Type' options={['TXT', 'A', 'MX', 'NS', 'CNAME', 'SRV', 'AAAA'].map(value => ({ value, text: value }))} value={this.state.newType} onChange={this.onEditChange('newType')} />
              </Form.Group>
              <span className="actions add">
                <Button icon='add' onClick={this.addRecord} />
              </span>
              {this.props.records ? this.props.records.map((record, idx) => (
                <div className="record">
                  <Form.Group widths='equal' key={idx}>
                    <Form.Input disabled placeholder='Sub-Domain' value={record.name} />
                    <Form.Input onChange={this.onEditChange('data')} disabled={this.state.editing !== idx} placeholder='IP' value={this.state.editing === idx ? this.state.data : record.data} />
                    <Form.Select disabled placeholder='Type' value={record.type} options={['TXT', 'A', 'MX', 'NS', 'CNAME', 'SRV', 'AAAA'].map(value => ({ value, text: value }))}/>
                  </Form.Group>
                  {
                    this.state.editing === idx ?
                    <span className="actions">
                      <Button icon='save' onClick={this.saveEdit} />
                      <Button icon='remove' onClick={this.cancelEdit} />
                    </span> :
                    <span className="actions">
                      <Button icon='edit' onClick={() => this.edit(idx)} disabled={!!this.state.editing} />
                    </span>
                  }
                </div>
              )) : null}
            </Form>
          </Segment> :
          <Segment><h1>Select Domain For Editing</h1></Segment>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DnsManagerRouteComponent/DnsManagerRoute.js